/* eslint-disable import/no-cycle */
import moment from 'moment'
import * as Yup from 'yup'

import { isEmpty } from 'helpers/utils'
import {
  fullAlphabetic,
  refundPnr,
  refundUsaVcr,
  refundPhone,
  refundPassangers
} from 'helpers/validations'

export const validationSchema = translations =>
  Yup.object().shape({
    fullNames: Yup.array()
      .of(
        Yup.string()
          .test(
            'contactName',
            translations('international-refund-form.validation.contact-name.pattern'),
            value => isEmpty(value) || new RegExp(refundPassangers).test(value)
          )
          .required(translations('international-refund-form.validation.full-name-required'))
      )
      .required(translations('international-refund-form.validation.full-name-required')),
    ticketNumbers: Yup.array()
      .of(
        Yup.string()
          .matches(refundUsaVcr, {
            message: translations('international-refund-form.validation.ticket-number-invalid')
          })
          .min(13, translations('international-refund-form.validation.ticket-number-invalid'))
          .required(translations('international-refund-form.validation.ticket-numbers-required'))
      )
      .required(translations('international-refund-form.validation.ticket-numbers-required')),
    reservationCode: Yup.string()
      .matches(refundPnr, {
        message: translations('international-refund-form.validation.reservation-code-pattern')
      })
      .required(translations('international-refund-form.validation.reservation-code-required')),
    flightDate: Yup.string()
      .test(
        'flightDate',
        translations('international-refund-form.validation.flight-date-invalid'),
        value => {
          return moment(value).isValid()
        }
      )
      .required(translations('international-refund-form.validation.flight-date-required')),
    reasonForReturn: Yup.string().required(
      translations('international-refund-form.validation.refund-reason-required')
    ),
    sectionReturn: Yup.string(),
    fullTicket: Yup.bool(),
    nameOfPayer: Yup.string()
      .test(
        'nameOfPayer',
        translations('international-refund-form.validation.payer-name-pattern'),
        value => isEmpty(value) || new RegExp(fullAlphabetic).test(value)
      )
      .required(translations('international-refund-form.validation.payer-name-required')),
    placeOfResidence: Yup.string().required(
      translations('international-refund-form.validation.residence-required')
    ),
    email: Yup.string()
      .email(translations('international-refund-form.validation.email-pattern'))
      .required(translations('international-refund-form.validation.email-required')),
    phone: Yup.string()
      .test(
        'phone',
        translations('international-refund-form.validation.phone-pattern'),
        value => isEmpty(value) || new RegExp(refundPhone).test(value)
      )
      .required(translations('international-refund-form.validation.phone-required')),
    termsAndConditions: Yup.bool().oneOf(
      [true],
      translations('international-refund-form.validation.accept-conditions-required')
    ),
    observations: Yup.string().max(
      150,
      translations('international-refund-form.validation.observations.max-length')
    ),
    validationField: Yup.mixed().test(
      'fullTicketOrSectionReturn',
      translations('international-refund-form.error-one-required'),
      function(_, context) {
        const { sectionReturn, fullTicket } = context.parent
        if (!sectionReturn && !fullTicket) {
          return context.createError({
            path: 'sectionReturn',
            message: translations('international-refund-form.error-one-required')
          })
        }
        return true
      }
    )
  })
